import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { PenTool, GraduationCap } from "lucide-react";

interface JoinTeamModalProps {
    isMobile?: boolean;
}

export const JoinTeamModal = ({ isMobile }: JoinTeamModalProps) => {
    // Form Linkleri
    const MENTOR_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSfLxWh4oAS7aBfMKfbumE-r-tApzTIGfGONmso8yHO-6WLaAQ/viewform?usp=sharing&ouid=104103616882546610782";
    const CONTENT_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLScsxfPmFATjVUeBEYp5xeaMgDebkDzRAaAZU1A2VprPVi453w/viewform?usp=publish-editor";

    return (
        <Dialog>
            <DialogTrigger asChild>
                <Button
                    variant="outline"
                    className={isMobile
                        ? "w-full border-brand-primary text-brand-primary hover:bg-brand-primary hover:text-white h-11"
                        : "hidden md:flex border-brand-primary text-brand-primary hover:bg-brand-primary hover:text-white"
                    }
                >
                    Ekibe Katıl!
                </Button>
            </DialogTrigger>

            {/* z-[1001] ile mobil menünün önüne geçmesini sağladık */}
            <DialogContent className="z-[1001] bg-[#0F172A]/95 border-white/10 backdrop-blur-xl text-white sm:max-w-[425px] rounded-2xl border-none shadow-2xl">
                <DialogHeader>
                    <DialogTitle className="text-2xl font-bold text-center mb-2 text-white">
                        Kampüs Mentorluk <span className="text-[#4F46E5]">Ailesine Katıl</span>
                    </DialogTitle>
                    <DialogDescription className="text-slate-400 text-center font-medium">
                        Yeteneklerine uygun alanı seç ve aramıza katıl!
                    </DialogDescription>
                </DialogHeader>

                <div className="grid gap-4 py-6">
                    {/* Mentör Ol Butonu */}
                    <Button
                        onClick={() => window.open(MENTOR_FORM_URL, "_blank")}
                        className="h-24 bg-gradient-to-br from-[#4F46E5] to-[#3730A3] hover:from-[#4338CA] hover:to-[#312E81] transition-all duration-300 flex flex-col gap-2 items-center justify-center group border-none shadow-lg shadow-indigo-500/20"
                    >
                        <div className="flex items-center gap-2 font-black text-xl tracking-tight text-white">
                            <GraduationCap className="h-6 w-6 group-hover:scale-110 transition-transform text-white" />
                            Mentör Ol
                        </div>
                        <span className="text-[10px] font-bold opacity-80 uppercase tracking-[0.2em] text-white">
                            YKS Tecrübeni Kazanca Dönüştür
                        </span>
                    </Button>

                    {/* İçerik Üreticisi Ol Butonu */}
                    <Button
                        onClick={() => window.open(CONTENT_FORM_URL, "_blank")}
                        variant="outline"
                        className="h-24 border-white/10 bg-white/5 hover:bg-white/10 text-white flex flex-col gap-2 items-center justify-center transition-all group"
                    >
                        <div className="flex items-center gap-2 font-black text-xl tracking-tight text-slate-200">
                            <PenTool className="h-6 w-6 group-hover:rotate-12 transition-transform text-slate-200" />
                            İçerik Üreticisi Ol
                        </div>
                        <span className="text-[10px] font-bold opacity-40 uppercase tracking-[0.2em] text-slate-400">
                            Sosyal Medyada Bizimle Büyü
                        </span>
                    </Button>
                </div>

                <div className="flex items-center justify-center gap-2 py-2 border-t border-white/5">
                    <span className="text-[9px] text-slate-500 uppercase font-black tracking-widest italic">
                    </span>
                </div>
            </DialogContent>
        </Dialog>
    );
};